import(/* webpackMode: "eager", webpackExports: ["ROICalculatorClient"] */ "/opt/buildhome/repo/components/calculator/ROICalculatorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/ToolLayout.tsx");
